export default "__VITE_ASSET__CHOtnBt1__"